// extracted by mini-css-extract-plugin
module.exports = {"info":"a2","dealer":"a3","dealerName":"a4","dealerAddress":"a5","actions":"a6","button":"a7"};